import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Loader";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { googleLogin } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/auth/sign-in", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await googleLogin(decodeURIComponent(match[1]));
        window.history.replaceState(null, "", window.location.pathname);
        navigate(user.onboarding_completed ? "/home" : "/onboarding", { replace: true });
      } catch {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/auth/sign-in", { replace: true });
      }
    })();
  }, [googleLogin, navigate]);

  return <Loader label="Signing you in…" />;
}
